"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _Functions = require("UIComponents/core/Functions");

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _default = _react.default.createClass({
  displayName: "UIRouterTab",
  propTypes: (0, _extends2.default)({
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    onClick: _react.PropTypes.func,
    to: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.shape({
      pathname: _react.PropTypes.string,
      query: _react.PropTypes.object,
      hash: _react.PropTypes.string,
      state: _react.PropTypes.object
    })])
  }, _UITab.default.propTypes),
  contextTypes: {
    router: _react.PropTypes.object
  },
  getDefaultProps: function getDefaultProps() {
    return _UITab.default.defaultProps;
  },
  handleClick: function handleClick(syntheticEvt) {
    var onClick = this.props.onClick;
    (0, _Functions.callIfPossible)(onClick, syntheticEvt);

    if (syntheticEvt.source && syntheticEvt.source.defaultPrevented) {
      return;
    }

    (0, _invariant.default)(this.context.router, '<UIRouterTab>s rendered outside of a router context cannot navigate.');

    if (syntheticEvt.source && !syntheticEvt.source.metaKey) {
      syntheticEvt.source.preventDefault();
      this.context.router.push(this.props.to);
    }
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        to = _this$props.to,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "to"]);
    var classes = (0, _classNames.default)(className, 'private-router-tab');
    return _react.default.createElement(_UITab.default, (0, _extends2.default)({}, rest, {
      className: classes,
      onClick: this.handleClick,
      href: this.context.router.createHref(to)
    }), children);
  }
});

exports.default = _default;
module.exports = exports.default;